import { render, staticRenderFns } from "./SignupConfirmationFinalStep.vue?vue&type=template&id=6afe286d"
import script from "./SignupConfirmationFinalStep.vue?vue&type=script&lang=js"
export * from "./SignupConfirmationFinalStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports